import { render } from "./IndexExpiring.vue?vue&type=template&id=54d93c74"
import script from "./IndexExpiring.vue?vue&type=script&lang=js"
export * from "./IndexExpiring.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__